import { cpf, cnpj } from 'cpf-cnpj-validator'

export const validateCpf = (value: string) => cpf.isValid(value || '')

export const validateCnpj = (value: string) => cnpj.isValid(value || '')

export const validateFullName = (value: string) =>
  !!(value && value.split(' ').filter((name) => name !== '').length > 1)

export const validateCep = (cep: string) => cep.replace(/\D/g, '').length === 8
